import { useEffect, useState } from "react";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  GetOneFlowActionEvaluator,
  GetShortListNumbers,
} from "../../../../Redux/Reducers/Manager/FlowActionEvaluator";
import { useParams } from "react-router-dom";
import { SaveSubTaskForEvaluation } from "../../../../Redux/Reducers/Manager/SubTask";
const ShortListInfo = (props) => {
  const dispatch = useDispatch();
  const { subTaskId } = useParams();
  const lang = useSelector((state) => state.languageReducer.Language);
  const FlowActionEvaluator = useSelector(
    (state) => state.FlowActionEvaluator.FlowActionEvaluator
  );
  const ShortListNumbers = useSelector(
    (state) => state.FlowActionEvaluator.ShortListNumbers
  );
  const ApplicationBySubTask = useSelector(
    (state) => state.SubTask.ApplicationBySubTask
  );
  const [ReasonDescription, setReasonDescription] = useState();
  const [refresh, setrefresh] = useState(0);
  const getData = async () => {
    const data = await dispatch(
      GetOneFlowActionEvaluator({
        subTaskId: subTaskId,
      })
    );
    console.log(data.payload, "dssss");

    if (data.payload) {
      props.setisShortList(data.payload.isShortlisted);
      props.setReasonDescription(data.payload.reasonDescription);
    }
  };
  useEffect(() => {
    getData();
    dispatch(
      GetShortListNumbers({
        subjectId: ApplicationBySubTask?.subjectId,
        userId: ApplicationBySubTask?.userId,
      })
    );
  }, [ApplicationBySubTask?.subjectId, props.refrish, refresh]);

  console.log(ApplicationBySubTask, "ApplicationBySubTask");

  return ApplicationBySubTask ? (
    <>
      <div
        className="form-grid"
        style={{ width: "50%", alignItems: "center", margin: "0 auto" }}
      >
        <InputAHSF
          fieldsName="NumberAllowedShortList"
          show={true}
          lang={lang}
          disabled={true}
          value={ShortListNumbers?.numberAllowed}
          showValidationMessage={false}
        />

        <InputAHSF
          fieldsName="NumberRequestsAddedShortlist"
          show={true}
          lang={lang}
          disabled={true}
          value={ShortListNumbers?.numberRequestsAdded}
          showValidationMessage={false}
        />

        <InputAHSF
          fieldsName="NumberRemainingShortlist"
          show={true}
          lang={lang}
          disabled={true}
          value={ShortListNumbers?.numberRemaining}
          showValidationMessage={false}
        />
      </div>
      <div className="form-gridSecound">
        <AllDropDownsAHSF
          fieldsName="IsApplicationShortList"
          lang={lang}
          show={true}
          disabled={props.disabled}
          yesNo={true}
          dropdownType="normal"
          arrayOoptionList={
            lang == "en"
              ? [
                  { text: "Yes", value: true },
                  { text: "No", value: false },
                ]
              : [
                  { text: "نعم", value: true },
                  { text: "لا", value: false },
                ]
          }
          KeyText={"text"}
          KeyValue={"value"}
          value={FlowActionEvaluator?.isShortlisted}
          onChange={async (e) => {
            props.setisShortList(JSON.parse(e.target.value));
            var saved = await dispatch(
              SaveSubTaskForEvaluation({
                toOrderOnShortList: JSON.parse(e.target.value),
                explainWhy: ReasonDescription
                  ? ReasonDescription
                  : FlowActionEvaluator.reasonDescription,
                subTaskId: subTaskId,
              })
            );
            if (saved.payload) {
              setrefresh(refresh + 1);
            }
          }}
        />
        <TextAreaAHSF
          fieldsName="ExplainReason"
          show={true}
          lang={lang}
          type=""
          disabled={props.disabled}
          onChange={(e) => {
            props.setReasonDescription(e.target.value);
            setReasonDescription(e.target.value);
          }}
          defaultValue={FlowActionEvaluator?.reasonDescription}
        />
      </div>
    </>
  ) : (
    ""
  );
};

export default ShortListInfo;
